// extracted by mini-css-extract-plugin
export default {"bg-image":"SignUp_bg-image__Ka8jH","layer":"SignUp_layer__pkpRR"};